import styled from '@emotion/styled';
import { PropsWithChildren } from 'react';
import AdSupportedLayout from '~/modules/Ads/AdSupportedLayout';

export default function LiveTvLayout({ children }: PropsWithChildren) {
  return (
    <Shell>
      <Main>
        <AdSupportedLayout placementPrefix="live-tv" contentScroll>
          {children}
        </AdSupportedLayout>
      </Main>
    </Shell>
  );
}

const Shell = styled.div`
  height: 100vh;
  height: 100dvh;
  background: var(--walky-canvas);
  color: var(--walky-ink);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-top: 4px solid var(--walky-orange);
`;

const Main = styled.main`
  flex: 1;
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px 16px;

  @media (max-width: 560px) {
    padding: 10px;
  }
`;
